module.exports = __webpack_public_path__ + "17e0f34a51f69c0ddaf5c11ba6708eb1.svg";